window.addEventListener("scroll", (e) => {
  if (window.innerWidth < 768) {
    const button = document.querySelector("[data-product-form]");
    const offsetTop = button.offsetTop;
    if (document.scrollingElement.scrollTop > offsetTop + 100) {
      button.classList.add("fixed");
    } else {
      button.classList.remove("fixed");
    }
  }
});

/* hide variant unavailable start */
const variantSelects =  document.querySelector('.product__block__variants');
const pickerType = (variantSelects.querySelectorAll('fieldset').length > 0) ? 'radios' : 'selects';
const fieldsets = (pickerType == 'radios') ? Array.from(variantSelects.querySelectorAll('fieldset')) : Array.from(variantSelects.querySelectorAll('.product-form__input--dropdown'));
const productJson = JSON.parse(variantSelects.querySelector('[type="application/json"]').textContent);
let selectedOptions = [];
variantSelects.addEventListener('change', rebuildOptions);
rebuildOptions();
function validCombo(inputValue, optionLevel) {
  for(let i = 0; i < productJson.length; i++) {
    if(optionLevel == 1){
      if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == inputValue) {  return true; }
    } else {
      if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == selectedOptions[1] && productJson[i].option3 == inputValue) {  return true; }
    }
  }
}

function rebuildOptions() {
  selectedOptions = fieldsets.map((fieldset) => {
    return (pickerType == 'radios') ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : Array.from(fieldset.querySelectorAll('select'), (select) => select.value);
  });
  for(let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
    const inputs = (pickerType == 'radios') ? fieldsets[optionLevel].querySelectorAll('input') : fieldsets[optionLevel].querySelectorAll('option');
    inputs.forEach(input => {
      input.disabled = (validCombo(input.value,optionLevel)) ? false : true;
      if(pickerType == 'radios'){
        const label = fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);
        const parentRadioSwatch = label.closest('radio-swatch');
        if (parentRadioSwatch) {
          parentRadioSwatch.style.display = (input.disabled) ? "none" : "";
        }
      } else {
        input.hidden = (validCombo(input.value,optionLevel)) ? false : true;
      }
    });
  }

  for (let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
    if(pickerType == 'radios'){
      if(fieldsets[optionLevel].querySelector('input:checked').disabled === true) {
        const inputElement = fieldsets[optionLevel].querySelector('input:not(:disabled)');
        if (inputElement) {
          inputElement.checked = true;
          change=true;
          inputElement.dispatchEvent(new Event('change'));
        } 
      }
    } else {
      if(fieldsets[optionLevel].querySelector('option:checked').disabled === true) {
          change = (fieldsets[optionLevel].querySelector('option:not(:disabled)').selected = "selected");
      }
    }

    if(change) variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
/* hide variant unavailable end */